export var valuesRouteType = ["SmartMobilityWorld", "Tube"];
/*

*/ 
//# sourceMappingURL=RouteType.js.map